import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from "dayjs";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "promote-list",
  data: function data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        cityId: null,
        company: null,
        phone: null,
        userName: null,
        topType: this.$route.params.topType // 1 季度 2 充值 3 会员
      },
      // 搜索表单

      filterList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      promotionInfo: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getHouseFilterType();
            _this.getMaxPromotionNumber();
            if (_this.$route.params.type == "quarter") {
              _this.$route.meta.title = "季度置顶池";
            } else if (_this.$route.params.type == "brand") {
              _this.$route.meta.title = "充值置顶池";
            } else if (_this.$route.params.type == "member") {
              _this.$route.meta.title = "会员置顶池";
            } else if (_this.$route.params.type == "choiceness") {
              _this.$route.meta.title = "精选房源置顶池";
            }
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getMaxPromotionNumber: function getMaxPromotionNumber() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getMaxPromotionNumber({
                cityId: _this2.searchForm.cityId,
                topType: _this2.searchForm.topType
              });
            case 1:
              res = _context2.v;
              _this2.promotionInfo = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    pageChange: function pageChange(page) {
      this.searchForm.pageNum = page;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pageNum = 1;
              }
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getHouseTopList(_this3.searchForm);
            case 1:
              res = _context3.v;
              res.data.content.forEach(function (item) {
                item.lastExtendTime = dayjs(item.lastExtendTime).format("YYYY-MM-DD HH:mm:ss");
              });
              _this3.tableData = res.data.content;
              _this3.total = res.data.totalCount;
              _this3.tableLoading = false;
              _this3.getUserListByIds(_this3.tableData, "userId");
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.getHouseFilterType();
            case 1:
              res = _context4.v;
              _this4.filterList = res.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  }
};